import { createSlice } from '@reduxjs/toolkit';
import { SiteAgent } from 'types';
import { getListSiteCharge } from './thunk';

interface InitialState {
  sites: SiteAgent[];
  loading: boolean;
}

const initialState: InitialState = {
  sites: [],
  loading: false,
};

export const siteListChargeSlice = createSlice({
  name: 'siteListChargeSlice-container',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getListSiteCharge.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getListSiteCharge.fulfilled, (state, { payload }) => {
      state.sites = payload.sites;
      state.loading = false;
    });
    builder.addCase(getListSiteCharge.rejected, (state) => {
      state.sites = [];
      state.loading = false;
    });
  },
});

export default siteListChargeSlice.reducer;
